<div class="feedback-form">
  <h3 class="heading">Your Feedback is valuable for us</h3>
  <div class="form-box">
    <div class="field-container">
      <h5>Your name</h5>
      <label>
        <input class="field" type="text" autocomplete="off" placeholder="Enter your name" [formControl]="name">
      </label>
    </div>
    <div class="field-container">
      <h5>Email</h5>
      <label>
        <input class="field" type="text" autocomplete="off" placeholder="Enter your email" [formControl]="email">
      </label>
    </div>
    <div class="field-container">
      <h5>Feedback</h5>
      <label>
        <textarea rows="5" class="field" type="text" autocomplete="off" placeholder="Please give your feedback here"
                  [formControl]="suggestion"></textarea>
      </label>
    </div>
  </div>
  <button *ngIf="!isLoading" class="post-btn" mat-raised-button (click)="onSubmit()" color="primary">SUBMIT</button>
  <mat-spinner [strokeWidth]="3" [diameter]="30" color="primary" *ngIf="!!isLoading"></mat-spinner>
</div>
